// Page Accueil (connecté) : la porte du tableau de service. Une phrase d'état en tête (ce qui est dû), une seule
// action pleine (commencer la séance), les séances à faire maintenant (retards puis celles du jour, la même ligne
// qu'Aujourd'hui), la suite réelle du premier J0 du jour, puis le rythme : la série des sept derniers jours en
// points et mot, et le prochain partiel avec sa jauge et son verdict. Pas de héros, pas de tuiles, pas de camembert.
import { html } from '../../core/html.js';
import { state } from '../../core/store.js';
import { ico } from '../icones.js';
import { renderSeance } from '../components/taskRow.js';
import { renderSequenceJ, sequenceDepuis, sequenceDe, J_DEFAUT } from '../components/accueil-sequence.js';

var MAX_LIGNES = 5;

function dateLongue(ymd) {
    var s = window.parseDateLocal(ymd).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
    return s.charAt(0).toUpperCase() + s.slice(1);
}
function pluriel(n, un, des) { return n + ' ' + (n > 1 ? des : un); }
function faite(t) { return t.status === 'done'; }

// La phrase d'état : une seule chose à lire, jamais un chiffre seul.
function phraseEtat(aFaire, retard, duJour) {
    if (!duJour.length && !retard.length) return 'Rien de prévu aujourd\'hui.';
    if (!aFaire.length && !retard.length) return 'Tout est fait pour aujourd\'hui.';
    if (!aFaire.length) return pluriel(retard.length, 'séance en retard à rattraper.', 'séances en retard à rattraper.');
    return pluriel(aFaire.length, 'séance à faire aujourd\'hui.', 'séances à faire aujourd\'hui.');
}

// Les sept derniers jours : chaque jour porte son point et son mot (fait, manqué, en cours, rien de prévu).
function serie7(td) {
    var parDate = {};
    state.tasks.forEach(function(t) { (parDate[t.date] = parDate[t.date] || []).push(t); });
    return window.statsJours(7).map(function(d) {
        var ts = parDate[d] || [], faites = ts.filter(faite).length, etat, mot;
        if (!ts.length) { etat = 'vide'; mot = 'rien de prévu'; }
        else if (faites === ts.length) { etat = 'fait'; mot = pluriel(faites, 'séance faite', 'séances faites'); }
        else if (d === td) { etat = 'en-cours'; mot = faites + ' / ' + ts.length + ' faites, en cours'; }
        else { etat = 'manque'; mot = faites + ' / ' + ts.length + ' faites'; }
        var x = window.parseDateLocal(d);
        return { date: d, etat: etat, mot: mot, lettre: x.toLocaleDateString('fr-FR', { weekday: 'narrow' }).toUpperCase(), long: window.formatDateFr(d) };
    });
}

// Le mot sous les points : à zéro, il dit OÙ la série s'est rompue plutôt que de répéter le zéro — cinq points
// verts au-dessus d'un « série à zéro » se lisait comme une contradiction.
function motSerie(jours, streak) {
    if (streak > 0) return html`<b class="num">${pluriel(streak, 'jour', 'jours')}</b> de série sans retard.`;
    var rompu = null;
    for (var i = jours.length - 1; i >= 0; i--) { if (jours[i].etat === 'manque') { rompu = jours[i]; break; } }
    if (rompu) return html`Série interrompue le ${rompu.long} : <span class="num">${rompu.mot}</span>. Un jour entièrement coché la relance.`;
    if (jours.every(function(j) { return j.etat === 'vide'; })) return 'Aucune séance ces sept derniers jours.';
    return 'Série à zéro : coche toutes les séances du jour pour la relancer.';
}

function blocSerie(td, streak) {
    var jours = serie7(td);
    return html`<div class="acc-bloc" aria-labelledby="acc-serie-titre">
        <h3 id="acc-serie-titre" class="acc-bloc-titre">${ico('flame', { taille: 18 })}Série</h3>
        <ol class="acc-serie" aria-label="Les sept derniers jours">${jours.map(function(j) {
            return html`<li class="acc-jour acc-jour--${j.etat}${j.date === td ? ' acc-jour--auj' : ''}" title="${j.long} : ${j.mot}"><span class="acc-jour-lettre" aria-hidden="true">${j.lettre}</span><span class="acc-jour-point" aria-hidden="true"></span><span class="sr-only">${j.long} : ${j.mot}</span></li>`;
        })}</ol>
        <p class="acc-bloc-mot">${motSerie(jours, streak)}</p>
    </div>`;
}

function blocPartiel() {
    var ex = window.activeExams()[0];
    if (!ex) {
        return html`<div class="acc-bloc" aria-labelledby="acc-partiel-titre">
            <h3 id="acc-partiel-titre" class="acc-bloc-titre">${ico('graduation-cap', { taille: 18 })}Prochain partiel</h3>
            <p class="acc-bloc-mot">Aucun partiel daté. <button type="button" class="lien-bouton" data-action="openExams">Ajouter une date</button> : les items concernés passent en tête, et l'accueil dira si le rythme suffit.</p>
        </div>`;
    }
    var p = window.statsProjection(ex.specs || [], ex.date, ex.marge), j = window.daysUntil(ex.date);
    var verdict, ton = '';
    if (p.reste === 0) { verdict = 'Tous les J0 de ces matières sont vus.'; ton = 'ok'; }
    else if (p.fin) { if (p.aTemps) { verdict = 'Au rythme actuel, fini le ' + window.formatDateFr(p.fin) + '.'; ton = 'ok'; } else { verdict = 'Au rythme actuel : ' + window.formatDateFr(p.fin) + ', après le partiel.'; ton = 'warn'; } }
    else verdict = 'Pas encore de rythme à projeter : coche des J0.';
    return html`<div class="acc-bloc" aria-labelledby="acc-partiel-titre">
        <h3 id="acc-partiel-titre" class="acc-bloc-titre">${ico('graduation-cap', { taille: 18 })}Prochain partiel</h3>
        <p class="acc-partiel"><span class="acc-partiel-nom">${ex.name || 'Partiel'}</span><span class="puce puce-accent">${j === 0 ? 'Aujourd\'hui' : 'J-' + j}</span><span class="acc-partiel-date num">${window.formatDateFr(ex.date)}</span></p>
        <div class="acc-jauge" role="progressbar" aria-valuemin="0" aria-valuemax="${p.total}" aria-valuenow="${p.vus}" aria-label="Sous-parties vues pour ${ex.name || 'ce partiel'}">
            <div class="jauge-piste acc-jauge-piste"><span class="jauge-val" style="--p:${(p.total ? p.vus / p.total : 0).toFixed(3)}"></span></div>
            <span class="acc-jauge-texte num">${p.vus} / ${p.total} sous-parties vues</span>
        </div>
        <p class="acc-bloc-mot${ton ? ' acc-verdict--' + ton : ''}">${verdict} <button type="button" class="lien-bouton" data-action="openExams">Tous les partiels</button></p>
    </div>`;
}

export function renderAccueil() {
    var td = window.todayStr();
    if (state.serverStatus === 'offline' && state.tasks.length === 0) return window.brut(window.renderServeurInjoignable());
    if (!state.tasks.length) {
        return html`<div class="acc acc--vide fade-in">
            <div class="vide carte">${ico('calendar-dots')}<h2>Aucun planning pour l'instant</h2><p>Choisis tes matières et lance l'ordonnancement : chaque item reviendra au bon moment.</p>
                <div class="acc-vide-actions"><button type="button" class="btn btn-primaire" data-action="ouvrirAutoplan">${ico('magic-wand', { taille: 18 })}Planifier</button><a class="btn btn-fantome" href="${window.routeUrl('catalogue')}">Parcourir le catalogue</a></div>
            </div>
            <section class="acc-section" aria-labelledby="acc-ex-titre">
                <h2 id="acc-ex-titre">Ce que donne un item planifié aujourd'hui</h2>
                ${renderSequenceJ(sequenceDepuis(td, J_DEFAUT), { td: td, label: 'Séquence J d\'un item planifié aujourd\'hui' })}
            </section>
        </div>`;
    }
    var duJour = state.tasks.filter(function(t) { return t.date === td; });
    var aFaire = duJour.filter(function(t) { return !faite(t); });
    var retard = state.tasks.filter(function(t) { return t.date < td && !faite(t); });
    // Deux durées, jamais la même sous deux comptes différents : l'en-tête chiffre ce que sa phrase nomme (les
    // séances du jour, ou les retards quand la journée est déjà faite), la section chiffre les treize lignes.
    var estimEntete = window.estimateDayMinutes(aFaire.length ? aFaire : retard);
    var estimTotal = window.estimateDayMinutes(aFaire.concat(retard));
    var streak = window.computeStreak();
    var retardTri = window.sortTasksForExams(retard), jourTri = window.sortTasksForExams(aFaire);
    var liste = retardTri.concat(jourTri);
    // Cinq lignes au plus : les retards d'abord, mais jamais au point de cacher la journée (trois retards, puis
    // les séances du jour ; s'il reste de la place, d'autres retards).
    var nRetards = Math.min(retardTri.length, Math.max(3, MAX_LIGNES - jourTri.length));
    var visibles = retardTri.slice(0, nRetards).concat(jourTri).slice(0, MAX_LIGNES);
    var premierJ0 = visibles.filter(function(t) { return t.type === 'J0' && t.date === td; })[0] || jourTri.filter(function(t) { return t.type === 'J0'; })[0];
    var suite = premierJ0 ? sequenceDe(premierJ0, state.tasks, td) : [];
    var resume = [dateLongue(td)];
    if (liste.length && estimEntete.total) resume.push('≈ ' + window.formatDuration(estimEntete.total));
    var prochain = null;
    if (!duJour.length && !retard.length) state.tasks.forEach(function(t) { if (t.date > td && !faite(t) && (!prochain || t.date < prochain)) prochain = t.date; });
    // Le titre de section dit ce que la section contient : « À faire maintenant » au-dessus de lignes à faire,
    // jamais au-dessus d'un bloc qui annonce le contraire de ce que la phrase d'état vient de dire.
    var titreSection = liste.length ? 'À faire maintenant' : (duJour.length ? 'La journée' : 'La suite');
    return html`<div class="acc fade-in">
        <header class="acc-entete">
            <div class="acc-entete-texte">
                <h1 class="acc-etat">${phraseEtat(aFaire, retard, duJour)}</h1>
                <p class="acc-resume num">${resume.join(' · ')}${retard.length ? html` · <span class="acc-retard">${pluriel(retard.length, 'en retard', 'en retard')}</span>` : ''}${streak > 0 ? html` · ${ico('flame', { taille: 14, classe: 'acc-flamme' })} ${streak} j de série` : ''}</p>
            </div>
            ${liste.length
                ? html`<a class="btn btn-primaire acc-action" href="${window.routeUrl('dashboard')}">${ico('play', { taille: 18 })}Commencer la séance</a>`
                : html`<a class="btn btn-primaire acc-action" href="${window.routeUrl('qcm')}">${ico('question', { taille: 18 })}S'entraîner aux QCM</a>`}
        </header>
        <section class="acc-section" aria-labelledby="acc-afaire-titre">
            <header class="acc-section-entete">
                <h2 id="acc-afaire-titre">${titreSection}</h2>
                ${liste.length ? html`<span class="acc-section-compte num">${pluriel(liste.length, 'séance', 'séances')}${estimTotal.total ? html` · ≈ ${window.formatDuration(estimTotal.total)}` : ''}</span>` : ''}
                ${liste.length > visibles.length ? html`<a class="acc-section-lien" href="${window.routeUrl('dashboard')}">Tout voir sur Aujourd'hui (${liste.length})${ico('arrow-right', { taille: 14 })}</a>` : ''}
            </header>
            ${visibles.length
                ? html`<div class="jour-liste">${visibles.map(function(t) { return renderSeance(t, { retard: t.date < td }); })}</div>`
                : (duJour.length
                    ? html`<div class="vide carte">${ico('check-circle')}<h3>Tout est coché</h3><p>${pluriel(duJour.length, 'séance faite', 'séances faites')} aujourd'hui. Une série de QCM pour finir, ou à demain.</p></div>`
                    : html`<div class="vide carte">${ico('sun')}<h3>${prochain ? html`Le planning reprend le ${window.formatDateFr(prochain)}` : 'Journée libre'}</h3><p>${prochain ? 'Rien à rattraper d\'ici là : la journée est à toi.' : 'Aucun jour planifié pour l\'instant : relance l\'ordonnancement depuis le calendrier.'}</p><a class="btn btn-fantome" href="${window.routeUrl('calendrier')}">Voir le calendrier</a></div>`)}
            ${suite.length ? html`<div class="acc-suite"><span class="acc-suite-mot">L'item <b class="num">${premierJ0.baseItemId || premierJ0.itemId}</b>, lu aujourd'hui, revient (écarts ajustés à ton rythme) :</span>${renderSequenceJ(suite, { td: td, compact: true, label: 'Prochaines révisions de l\'item ' + (premierJ0.baseItemId || premierJ0.itemId) })}</div>` : ''}
        </section>
        <section class="acc-section" aria-labelledby="acc-rythme-titre">
            <h2 id="acc-rythme-titre">Le rythme</h2>
            <div class="acc-rythme">${blocSerie(td, streak)}${blocPartiel()}</div>
        </section>
    </div>`;
}

window.renderAccueil = renderAccueil;
